import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    businessHours:
      '*Average response time guaranteed from Monday to Friday, 9 a.m. to 12 p.m. and from 2 p.m. to 5 p.m. On weekends, we respond to your requests within a day.',
    Chat: {
      subtitle:
        'In the case of loss, theft or fraudulent use of your means of payment.',
      tag: '1 h*',
      title: 'I have an emergency',
    },
    conversations: 'Access my messages',
    Email: {
      tag: '3 h*',
      title: 'I have a question',
    },
    FAQ: {
      description: 'Find the answers to your questions in the blink of an eye.',
      search: 'Browse our FAQ',
      title: 'Your answer is probably here',
    },
    subtitle:
      'An emergency or simply a question? We’re here to help you through all our channels.',
    team: {
      description: 'Clémence and your advisors accompany you on a daily basis.',
      title: 'Your Shine team',
    },
    title: 'Help center',
  },
  fr: {
    businessHours:
      '*Délai de réponse moyen garanti du lundi au vendredi de 9h à 12h et de 14h à 17h. Le week-end, nous répondons à vos demandes dans la journée.',
    Chat: {
      subtitle:
        'En cas de perte, de vol ou d’utilisation frauduleuse de vos moyens de paiement.',
      tag: '1 h*',
      title: 'J’ai une urgence',
    },
    conversations: 'Accéder à mes conversations',
    Email: {
      tag: '3 h*',
      title: 'J’ai une question',
    },
    FAQ: {
      description: 'Trouvez les réponses à vos questions en un clin d’oeil.',
      search: 'Consulter notre FAQ',
      title: 'Votre réponse se trouve sûrement ici',
    },
    subtitle:
      'Une urgence ou simplement une question ? Nous sommes à votre écoute sur tous nos canaux pour vous répondre.',
    team: {
      description:
        'Clémence et vos conseiller·es vous accompagnent au quotidien.',
      title: 'Votre équipe Shine',
    },
    title: 'Centre d’aide',
  },
} as const);

export default locales;
